import { getLoanApplicationById, getLoanById, patchUnSignLoanLenderBorrowerContract } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

interface useUnSignContractProps {
  loanId: string;
  loanApplicationId: string;
}

export const useUnSignContract = ({ loanId, loanApplicationId }: useUnSignContractProps) => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();
  const [loading, setLoading] = useState(false);

  const unSignLoanLenderBorrowerContract = async () => {
    setLoading(true);
    try {
      await patchUnSignLoanLenderBorrowerContract({ loanId });
      await waitUntilContractIsUnSigned();
      await setSnackbarNotification({
        msg: `${patchUnSignLoanLenderBorrowerContract.name}_fulfilled`,
        level: 'success',
      });
    } catch (error) {
      await setSnackbarNotification({
        error,
        msg: `${patchUnSignLoanLenderBorrowerContract.name}_rejected`,
        level: 'error',
      });
    }
    setLoading(false);
  };

  const waitUntilContractIsUnSigned = async (): Promise<void> => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      (async function waitGetLoanApplicationUnSigned() {
        attempts += 1;
        if (attempts > 5) return reject();
        const loan = await getLoanById({ loanId });
        if (loan?.loanApplicationSelected) {
          const loanApplication = await getLoanApplicationById({ loanApplicationId });
          if (!loanApplication?.loanLenderBorrowerContract.isSigned) {
            return resolve();
          }
        }
        setTimeout(await waitGetLoanApplicationUnSigned, 1000);
      })();
    });
  };
  return { unSignLoanLenderBorrowerContract, loading };
};
